/**
 * Node.JS/NPM Modules
 */
/**
 * Loacl Modules
 */
const events = require('./events');
const logger = require('./logger');
/**
 * Module Variables
 */
let ws;
let event_manager;
let config;
let authKey;
let signalingId = 'N/A';
let signalingVersion = 'N/A';
let mediaServerId = 'N/A';
let mediaServerVersion = 'N/A';
let maxBw;
let onConnectCall = () => {};
let onDisconnectCall = () => {};
let onPermissionsUpdate = () => {};
let onIceConfig = () => {};
let onAudioMute = () => {};
const TAG = '[signaling_module]';
/**
 * Module Functions
 */

/**
 * This is the init function. call it before any other function of this module.
 * this will set the event_manager and onDisconnectCall (callback) for this module.
 * @param  {EventEmitter} em          the switchrtc_core event_manager object
 * @param  {Function} _onDisconnectCall Will be called when the call is over
 */
let init = (em, _onConnectCall, _onDisconnectCall, _onIceConfig, _onPermissionsUpdate, _onAudioMute) => {
    event_manager = em;
    onConnectCall = _onConnectCall || onConnectCall;
    onDisconnectCall = _onDisconnectCall || onDisconnectCall;
    onIceConfig = _onIceConfig || onIceConfig;
    onPermissionsUpdate = _onPermissionsUpdate || onPermissionsUpdate;
    onAudioMute = _onAudioMute || onAudioMute;
};
/**
 * This function will try to connect to the signaling server via websocket.
 * if for some reason - the connection will fail, it will wait 1sec and will try to reconnect via
 * the _reconnect() function. see _reconnect() for more details.
 *
 * @param  {Object}   _config  JSON config object, contains signaling server websocket url
 * @param  {Boolean} isReconnection is this a reconnect attempt
 * @param  {Object} queryparams to attach to ws url
 * @param  {Function} callback this will be called when connected. with {Boolean} isReconnection as a param.
 */
let connect = (_config, isReconnection,queryParams,callback) => {
    if(ws) { // close existing socket
        ws.onopen = () => {};
        ws.onmessage = () => {};
        ws.onerror = () => {};
        ws.onclose = () => {};
        ws.close();
        ws = null;
    }
    let wsUrl = isReconnection ? config.signalingWS : _config.signalingWS;
    Object.keys(queryParams).forEach((key, index) => {
      if(index == 0) wsUrl += '?';
      else wsUrl += '&';
      wsUrl += `${key}=${queryParams[key]}`;
    });
    ws = new WebSocket(wsUrl);
    if(!isReconnection) config = _config;
    ws.onopen = () => {
        logger.debug(TAG, 'Connected To WS');
        // _keepAlive();
        callback();
    };
    ws.onmessage = _gotMessageFromServer;
    ws.onerror = (e) => {
        ws = null;
        logger.debug(TAG, 'connect(): connection error');
        event_manager.emit(events.CALL_ENDED, 'Failed to connect to server');
    };
    ws.onclose = () => {
        logger.debug(TAG, 'connect(): connection closed');
        ws = null;
        event_manager.emit(events.DISCONNECTED);
    };
};

// /**
//  * The Keep Alive Function (Will send and receive keep alive messages from and to signaling server)
//  *
//  */
// let _keepAlive = () => {
//     if (ws) {
//         logger.debug(TAG, 'Keeping Connection Alive...');
//         if (ws.readyState === ws.OPEN) ws.send(JSON.stringify({
//             'keepAlive': true
//         }));
//         setTimeout(_keepAlive, 10000);
//     }
// };

/**
 * Andler for Websocket onmessage events
 * @param  {String} message A JSON object as a String
 *
 */
let _gotMessageFromServer = (message) => {
    let signal = JSON.parse(message.data);
    let peer_connection = require('./peer_connection');
    logger.debug(TAG, 'got message from server: ' + message.data);

    if(signal.authKey) authKey = signal.authKey;

    if (signal.signalingId) {
        signalingId = signal.signalingId;
    }

    if (signal.signalingVersion) {
        signalingVersion = signal.signalingVersion;
    }

    if (signal.mediaServerId) {
        mediaServerId = signal.mediaServerId;
    }

    if (signal.mediaServerVersion) {
        mediaServerVersion = signal.mediaServerVersion;
    }

    if (signal.maxBw) {
        maxBw = signal.maxBw;
    }

    if (signal.permissions) {
        onPermissionsUpdate(signal.permissions);
    }

    if (signal.audioMute !== undefined) {
        onAudioMute(signal.audioMute);
    }

    if (signal.sdp) {

        // got iceServers config, first create peer connection
        if (signal.iceServers) {
            onIceConfig(signal.iceServers);
        }

        // set remote description
        peer_connection.onRemoteDescription(signal.sdp);

        // remote description set, start media if needed
        if (signal.iceServers) {
            onConnectCall();
        }
    } else if (signal.ice) {
        peer_connection.onRemoteIce(signal.ice);
    } else if (signal.disconnect) {
        logger.debug(TAG, 'Received disconnect, stopping...');
        onDisconnectCall(signal.reason);
        ws = null;
    } else if (signal.info) {
        event_manager.emit(events.SESSION_INFO_UPDATE, signal.info);
    } else if (signal.action) {
        switch (signal.action) {
            case 'recorder_custom_command':
                event_manager.emit(events.CUSTOM_RECORDER_COMMAND, signal.command);
                break;
            default:
                logger.warn(TAG, 'Unknown signal command:', signal.action);
                break;
        }
    } else if (signal.action_response) { // response to signal 'action'
        switch (signal.action_response) {
            case 'OK':
                if (signal.action_type === 'start_record_session') event_manager.emit(events.SESSION_RECORDING_ON, signal);
                else if (signal.action_type === 'stop_record_session') event_manager.emit(events.SESSION_RECORDING_OFF, signal);
                else if (signal.action_type === 'pause_record_session') event_manager.emit(events.SESSION_RECORDING_PAUSED, signal);
                else if (signal.action_type === 'resume_record_session') event_manager.emit(events.SESSION_RECORDING_RESUMED, signal);
                break;
            case 'FAIL':
                event_manager.emit(events.ERROR, new Error(signal.error));
                break;
            default:
                logger.warn(TAG, 'Unkown "action_response": ' + signal.action_response);
                break;
        }
    } else if (signal.screenShare) {
        event_manager.emit(events.REMOTE_SCREEN_SHARE_ADDED, signal);
    } else if(signal.chat) {
        event_manager.emit(events.CHAT_MESSAGE, signal.chat);
    }
};
/**
 * Sends Data to the Signaling server via Websocket
 * @param  {String} data JSON stringified
 *
 */
let send = (data) => {
    if (ws) {
        logger.debug(TAG, 'Sending message to server\n' + data);
        data = JSON.parse(data);
        data.authKey = authKey;
        data = JSON.stringify(data);
        ws.send(data);
    }
};

let getSignalingId = () => {
    return signalingId;
};

let getSignalingVersion = () => {
    return signalingVersion;
};


/**
 * Getter - MediaServerId (Media Server Id)
 * @return {String} Media Server Id
 */
let getMediaServerId = () => {
    return mediaServerId;
};

/**
 * Getter - MediaServerVersion (Media Server version)
 * @return {String} Media Server Id
 */
let getMediaServerVersion = () => {
    return mediaServerVersion;
};

let getMaxBw = () => {
    return maxBw;
};


/**
 * Closes the Websocket connection to the Signaling Server
 *
 */
let closeConnection = () => {
    if (ws) {
        ws.onclose = () => {};
        ws.close();
        ws = null;
    }
    authKey = null;
};

/**
 * Module Interface
 */

module.exports = {
    connect: connect,
    init: init,
    send: send,
    getSignalingId: getSignalingId,
    getSignalingVersion: getSignalingVersion,
    getMediaServerId: getMediaServerId,
    getMediaServerVersion: getMediaServerVersion,
    getMaxBw: getMaxBw,
    closeConnection: closeConnection
};



// WEBPACK FOOTER //
// ./src/Modules/signaling_module.js